module.exports = __webpack_public_path__ + "img/1544239486.49207231.jpg";